import { AxiosStatic } from 'axios';
import { toast } from 'react-toastify';
import { EXTERNAL_PROVIDE } from '../config/cacheKey';
import { ICheckOtpResponse } from '../models/account.model';
import { ApiResultModel } from '../models/common.model';
import { showToastMessage } from '../utility/toastHelper';
import { GetAccessTokenByRefreshToken } from './account.service';
import { getJwtToken, getTokenTime, setJwtToken } from './auth.service';
// Axios Interceptors Function
export default function setupAxiosInterceptors(axios: AxiosStatic) {
    const backGroundServices =
        [
            'GetPrimaryTerms',
            'GeneratePrimaryTerms',
            'GetAccessTokenByRefreshToken',
            'SaveVideo',
            'GetTotalBalance',
            'GetCustomerWalletInfo',
            'getNoticeCount',
            'GetRegistrationDuration',
            'CalculateLoanParams',
            'GetCustomerInfo',
            'Generate',
            'SetGoftinoUser',
            'GetWaitForCustomerApproveSales',
            'GetSummaryOfInProgressLoans',
            'GetExchangeRate'
        ];//,'GetWaitForCustomerApproveSales'];
    let count = 0;
    const refreshAccessToken = async () => {
        const { refToken } = getJwtToken();
        try {
            const response = await GetAccessTokenByRefreshToken({ refreshToken: refToken! });
            const data: ApiResultModel<ICheckOtpResponse> = response;
            if (data.isSuccess) {

                setJwtToken(data.data.jwt!, data.data.refreshToken!);
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + data.data.jwt;
                window.location.reload();

            } else {
                if (sessionStorage.getItem(EXTERNAL_PROVIDE)) {
                    if (window.ReactNativeWebView) {
                        window.ReactNativeWebView.postMessage(JSON.stringify({ action: 'close' }));
                    }
                    else {

                        window.location.href = '/';
                        setJwtToken('', '');
                    }
                }
                else {

                    window.location.href = '/';
                    setJwtToken('', '');
                }

            }
        } catch (err) {
            if (sessionStorage.getItem(EXTERNAL_PROVIDE)) {
                if (window.ReactNativeWebView) {
                    window.ReactNativeWebView.postMessage(JSON.stringify({ action: 'close' }));
                }
                else {

                    window.location.href = '/';
                    setJwtToken('', '');
                }
            }
            else {

                window.location.href = '/';
                setJwtToken('', '');
            }

        }
    };
    const showLoading = () => {
        const backdrop = document.body.getElementsByClassName("MuiBackdrop-root")[0] as HTMLElement;
        if (backdrop) {
            backdrop.style.display = "block";
            backdrop.style.visibility = "visible";

        } else {
            console.error('Backdrop not found');
        }

    };


    const hideLoading = () => {

        const backdrop = document.body.getElementsByClassName("MuiBackdrop-root")[0] as HTMLElement;
        if (backdrop) {
            backdrop.style.display = "none";
            backdrop.style.visibility = "hidden";

        }

    };

    // for first time 
    hideLoading();

    // Request Interceptor
    axios.interceptors.request.use(
        (config) => {
            const configServiceUrl = config.url?.split("/");
            let serviceName =
                configServiceUrl != undefined
                    ? configServiceUrl[configServiceUrl.length - 1]
                    : "";
            const { token, refToken } = getJwtToken();
            if (token) {
                config.headers['Authorization'] = `Bearer ${token}`;
            }
            // config.headers['Content-Type'] = 'application/json';
            if (!backGroundServices.includes(serviceName)) {

                showLoading();
            }
            return config;
        },
        (error) => {
            hideLoading();
            return Promise.reject(error);
        }
    );
    const { token } = getJwtToken();
    axios.interceptors.response.use(
        (response) => {
            interface arrStr {
                message: string;
                messageKind: number;
            }
            hideLoading();
            const { data } = response;

            if (!data.isSuccess) {

                if (data.messages !== undefined && data?.messages?.length > 0) {
                    const autoClose = data.autoClose
                    showToastMessage(data.messages, autoClose)

                }
                // if (window.location.hash !== '/otp' && messageErr.length > 0) {
                //     let msg = messageErr.join('\r\n');
                //     const showToast = (msg: string, data: { autoClose: any, type: ToastType }) => {
                //         toast[data.type](msg, {
                //             autoClose: data.autoClose > 0 ? data.autoClose : false,
                //             closeButton: true,
                //             className: 'newLineToast',
                //         });
                //     };
                //     showToast(msg, { autoClose: data.autoClose > 0 ? data.autoClose : false, type: toastType! });
                //     // toast[type](msg, {
                //     //     autoClose: data.autoClose > 0 ? data.autoClose : false,
                //     //     closeButton: true,
                //     //     className: 'newLineToast',
                //     // });
                // }
            }
            return response;
        },
        async (error) => {
            if (error.response?.status === 401) {
                try {
                    console.log('try')
                    count = count + 1
                    if (count < 3) {

                        await refreshAccessToken(); // Replace the mutation call with axios function
                    } else {
                        toast.error("لطفا دوباره تلاش کنید.");
                    }
                } catch (err) {
                    console.log('catch')
                    if (sessionStorage.getItem(EXTERNAL_PROVIDE)) {
                        if (window.ReactNativeWebView) {
                            window.ReactNativeWebView.postMessage(JSON.stringify({ action: 'close' }));
                        }
                        else {

                            window.location.href = '/';
                            setJwtToken('', '');
                        }
                    }
                    else {
                        window.location.href = '/';
                        setJwtToken('', '');
                    }
                }

            }
            // else if (error.message == 'Network Error') {
            //     toast.error("مشکل شبکه، لطفا دوباره تلاش کنید.");
            // }
            else if (error.response?.status === 404) {
                window.location.href = '#/maintenance';
            }

            //new config
            else if (error.response?.status === 403) {
                const errorMessage = error.response?.data?.messages || "دسترسی شما مجاز نیست.";
                const autoClose = error.response?.data.autoClose
                showToastMessage(errorMessage, autoClose);
            }
            else if (error.response?.status === 429) {
                const errorMessage = error.response?.data?.messages || "تعداد درخواست‌های شما بیش از حد مجاز است، لطفا بعداً تلاش کنید.";
                const autoClose = error.response?.data.autoClose
                showToastMessage(errorMessage, autoClose);
            }
            //new config

            if (error.message == 'Network Error' && token) {
                const errorMessage = error.response?.data?.messages || "مشکلی در برقراری ارتباط به وجود آمده است، لطفا دوباره تلاش کنید.";
                const autoClose = error.response?.data.autoClose
                showToastMessage(errorMessage, autoClose)
                getTokenTime();
                const { token } = getJwtToken();
                if (token) {
                    window.location.href = '#/maintenance'
                }
                else {
                    window.location.href = '/'
                }
            }
            if (error.message == 'Network Error' && !token) {
                const errorMessage = error.response?.data?.messages || "مشکلی در برقراری ارتباط به وجود آمده است، لطفا دوباره تلاش کنید.";
                const autoClose = error.response?.data.autoClose
                showToastMessage(errorMessage, autoClose)
                // toast.error(' مشکلی در برقراری به وجود آمده است، لطفا دوباره تلاش کنید.');
                // window.location.href = '#/maintenance'
                // window.location.href = '/';
                setJwtToken('', '');
            }


            hideLoading();
            return Promise.reject(error);
        }
    );
}

declare global {
    interface Window {
        ReactNativeWebView?: {
            postMessage: (message: string) => void;
        };
    }
}